module.exports = __webpack_public_path__ + "static/img/face_error2.98b9264a.jpg";